import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ResendButton,
  VerifyContainer, VerifyDivider, VerifyHeader, VerifyImage, VerifyText, VerifyWrapper,
} from './notVerifiedElements';
import img1 from '../../Images/NotVerified/notVerified-1.svg';
import useAuth from '../../Hooks/useAuth';
import { CarbonButton } from '../../Utils/generalStyles';
import useLogout from '../../Hooks/useLogout';
import axios from '../../Api/axios';

const index = () => {
  const { auth } = useAuth();
  const logout = useLogout();
  const navigate = useNavigate();

  const resend = () => {
    axios.post(
      '/resendVerify',
      JSON.stringify({
        email: auth.email,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'success') {
        alert('Email sent! Please check your email.');
      } else {
        alert('Error when sending email. Please try again later.');
      }
    }).catch((err) => {
      console.log(err);
      alert('Error when performing');
    });
  };

  const signOut = async () => {
    const confirmed = window.confirm('Are you sure you want to logout?');
    if (!confirmed) return;

    await logout();
    navigate('/login');
  };

  useEffect(() => {
    if (!auth.email || auth.verified === 1) navigate('/');
  }, []);

  return (
    <VerifyContainer>
      <VerifyWrapper>
        <VerifyImage alt="email" src={img1} />
        <VerifyHeader>Verify your email</VerifyHeader>
        <VerifyText>
          {`Please check ${auth.email} to verify your
        email address and activate your account.`}
        </VerifyText>
        <VerifyText>
          <ResendButton type="button" onClick={resend}>Click here!</ResendButton>
          to resend verification email.
        </VerifyText>
        <VerifyDivider />
        <CarbonButton colored onClick={signOut}>Logout</CarbonButton>
      </VerifyWrapper>
    </VerifyContainer>
  );
};

export default index;
